import { EditingBanner } from "./EditingBanner";

export default EditingBanner;
